import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-rapid-course',
    templateUrl: './rapid-course.component.html',
    styleUrls: ['./rapid-course.component.css'],
    standalone: false
})
export class RapidCourseComponent implements OnInit {

    // Use 'any' instead of IntersectionObserver type — not available in TS 2.x
  private observer: any = null;
 
  constructor(private router: Router) {}
 
  ngOnInit(): void {
    this.loadGoogleFonts();
  }
 
  ngAfterViewInit(): void {
    this.initScrollReveal();
  }
 
  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
 
  private loadGoogleFonts(): void {
    if (document.getElementById('sc-google-fonts')) { return; }
    const link = document.createElement('link');
    link.id   = 'sc-google-fonts';
    link.rel  = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Fredoka+One&family=Nunito:wght@400;600;700;800;900&display=swap';
    document.head.appendChild(link);
  }
 
  private initScrollReveal(): void {
    // IntersectionObserver is not typed in TS 2.x — cast to any
    const IoConstructor: any = (window as any).IntersectionObserver;
    if (!IoConstructor) {
      // Browser doesn't support it — just show everything immediately
      const all = document.querySelectorAll('.sc-reveal.sc-hidden');
      for (let i = 0; i < all.length; i++) {
        all[i].classList.remove('sc-hidden');
        all[i].classList.add('visible');
      }
      return;
    }
 
    const options = {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    };
 
    const self = this;   // capture 'this' — no arrow-function issues in TS 2.x
 
    this.observer = new IoConstructor(function(entries: any[]) {
      entries.forEach(function(entry: any) {
        if (entry.isIntersecting) {
          const el: HTMLElement = entry.target as HTMLElement;
          el.classList.remove('sc-hidden');
          el.classList.add('visible');
          // No optional chaining (?.) in TS 2.x — use explicit null check
          if (self.observer) {
            self.observer.unobserve(el);
          }
        }
      });
    }, options);
 
    const elements = document.querySelectorAll('.sc-reveal.sc-hidden');
    for (let i = 0; i < elements.length; i++) {
      this.observer.observe(elements[i]);
    }
  }
 
  scrollToBook(): void {
    window.location.href = 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/b5f96b35e36f62d6a559e0d3a8082321';
  }
 
  downloadBrochure(): void {
   window.location.href = 'https://drive.google.com/uc?export=download&id=1k6dGEJEEgEqC8r_zceF1Bi1FLuNSFuUy';
  }


  openExternalLink(): void {
    window.location.href = 'https://forms.zohopublic.in/sehyogacademy1/form/SICREGISTRATIONFORM/formperma/7-u7x8iPBrfIWZzrnDaE2OlbJQtRt1KqNKM-RYn3ucQ';
  }

  bookSlot():void{
    window.location.href = 'https://zfrmz.in/IHuVjmNxcB6LKXLnmR2z';
  }
}
